import { Component, OnInit, DoCheck, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../servicios/auth.service';
import * as auth0 from 'auth0-js';
import { DOCUMENT } from '@angular/common';
import { UserGuardService } from '../../../servicios/guards/user-guard.service';
import {HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { GlobalService } from '../../../services/global.service';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  // @Output() notiGlobal = new EventEmitter<any>();

  usuario: string;
  apellidonombre: string;
  role: string;
  seccional: string;
  secdet: string;
  userOK: boolean;
  noti;
  notificaciones: any[] = [];

  // para fs 1
  elem;
  fs: boolean;


  constructor(
    private http: HttpClient,
    private router: Router,
    public auth: AuthService,
    private global: GlobalService,
    public snackBar: MatSnackBar,
    @Inject(DOCUMENT) private document: any ) {
    this.fs = true;

   }

   cambiaRol( roli ) {
    localStorage.setItem('role', roli);
    console.log(roli);
  }

   openFullscreen() {
     this.fs = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    this.fs = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  // tslint:disable-next-line: member-ordering
  cantidad;
  getNoti() {
    // http://localhost:1337/api/nuevaope/getNoti
    this.http.get(`${environment.backendUrl}/api/nuevaope/getNoti`)
    .subscribe((datos: any[]) => {
      if ( datos ) {
        this.cantidad = datos[0]['cantid'];
        localStorage.setItem('global_cantidad', this.cantidad);
        // console.log('cantid:', this.cantidad);
      } else {
        // console.warn("NO HAY");
      }
    });
  }

  getNotiGlobal() {
    console.log('enviando de navbar al globo');
    // this.notiGlobal.emit( this.getNoti() );
    this.getNoti();
    // this.notiGlobal.emit( this.getNoti() );
  }

  // tslint:disable-next-line: member-ordering
  loadingborrar;

  onClick( id ) {
    console.log( id );
    const body = { 'id': id };
    // http://localhost:1337/api/nuevaope/borrarNoti
    this.loadingborrar = true;
    this.http.post(`${environment.backendUrl}/api/nuevaope/borrarNoti`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
      if (status.status === 200) {
        this.loadingborrar = false;
        this.snackBar.open(`LEIDO!`, 'Cerrar', {duration: 5000});
        this.getNoti();
        this.getNotiDet();
      }
      if (status.status === 500) {
       // console.warn("ERROR POST!");
       // console.log(JSON.stringify(status["error"]["code"]));
        this.snackBar.open(`FALLO! ${JSON.stringify(status['error']['code'])}`, 'Cerrar', {duration: 5000});
        this.loadingborrar = false;
      }
    });
  }

  ngOnInit() {
  this.getNoti();
    // para fs 2
    this.elem = document.documentElement;
    this.fs = true;
    // this.openFullscreen();

    this.usuario = localStorage.getItem('userId');
    this.apellidonombre = localStorage.getItem('apellidonombre');
    this.role = localStorage.getItem('role');
    this.seccional = localStorage.getItem('seccional');
    this.secdet = localStorage.getItem('seccdetalle');
    this.userOK = Boolean( localStorage.getItem('userOK') );
    this.noti = localStorage.getItem('notipend');
   // console.log(`notibar= ${this.noti}`);

    this.cantidad = localStorage.getItem('global_cantidad');
  }

  // tslint:disable-next-line: member-ordering
  loadingnotidet;

  getNotiDet() {
    this.loadingnotidet = true;
    // http://localhost:1337/api/nuevaope/getNotiDet
    this.http.get(`${environment.backendUrl}/api/nuevaope/getNotiDet`)
    .subscribe((datos: any[]) => {
      if ( datos ) {
        this.notificaciones = datos;
        // console.log(this.notificaciones);
        this.loadingnotidet = false;
        // console.log('notifis', notificaciones);
      } else {
        // console.warn("NO HAY");
        this.loadingnotidet = false;
      }
    });
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngDoCheck() {
    this.usuario = localStorage.getItem('userId');
    this.apellidonombre = localStorage.getItem('apellidonombre');
    this.role = localStorage.getItem('role');
    this.seccional = localStorage.getItem('seccional');
    this.secdet = localStorage.getItem('seccdetalle');
    this.userOK = Boolean( localStorage.getItem('userOK') );
    this.noti = localStorage.getItem('notipend');
    this.cantidad = localStorage.getItem('global_cantidad');
    // console.log('cantiglobal', this.cantidad);
    /*
    localStorage.setItem('userId', this.userGral);
    localStorage.setItem('apellidonombre',this.apellidonombreGral);
    localStorage.setItem('role', this.roleGral);
    localStorage.setItem('seccional',this.seccionalGral);
    localStorage.setItem('userOK',"true");
    */
  }

  borrarLocal() {
    localStorage.clear();
    // localStorage.clear() borra todo el local storage;
  }

  buscarNoticia(termino: string) {
    // console.log(termino);
    this.router.navigate( ['/buscar', termino] );
  }

  collapsear() {
    document.getElementById('colap').click();
  }

  // solo matias simula ser otro usuario
  // tslint:disable-next-line: member-ordering
  iduser;
  cambiaUser() {
    localStorage.setItem('userId', this.iduser);
    this.obtenerDatos();
  }

// tslint:disable-next-line: member-ordering
idsec;
  obtenerDatos() {
    // http://localhost:1337/api/simulalogin/obtener?userid=23115622
    this.http.get(`${environment.backendUrl}/api/simulalogin/obtener?userid=${this.iduser}`).subscribe((data: any[]) => {
      localStorage.setItem('userId', data[0][0]['id_usuario']);
            localStorage.setItem('apellidonombre', data[0][0]['apellidonombre']);
            localStorage.setItem('role', data[0][0]['rol']);
            // console.log('rol del local storage..');
            // console.log(localStorage.getItem('role'));
            localStorage.setItem('pre1be', data[0][0]['pregunta1']);
            localStorage.setItem('res1be', data[0][0]['respuesta1']);
            localStorage.setItem('pre2be', data[0][0]['pregunta2']);
            localStorage.setItem('res2be', data[0][0]['respuesta2']);
            localStorage.setItem('seccional', data[0][0]['id_seccional']);
            this.idsec = localStorage.getItem('seccional');
            localStorage.setItem('seccdetalle', data[0][0]['descripcion']);
            localStorage.setItem('userOK', 'true');
            // this.llenarNoti();
    });

  }

  // llenarNoti() {
  //   if (this.role === 'PAGADOR') {
  //       // http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
  //       this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
  //         .subscribe((data: any[]) => {
  //         this.noti = data[0]['TOT'];
  //         localStorage.setItem('notipend', this.noti);
  //         console.log(`noti= ${localStorage.getItem('notipend')}`);
  //       });
  //   } else {
  //     // http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
  //     this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
  //       .subscribe((data: any[]) => {
  //       this.noti = data[0]['TOT'];
  //       localStorage.setItem('notipend', this.noti);
  //       console.log(`noti= ${localStorage.getItem('notipend')}`);
  //     });
  //   }
  // }

}

